/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type GetLogsResponse,
    GetLogsResponseFromJSON,
    GetLogsResponseToJSON,
} from '../models/GetLogsResponse';
import {
    type LogPollResponse,
    LogPollResponseFromJSON,
    LogPollResponseToJSON,
} from '../models/LogPollResponse';
import {
    type TaskDetailsRequestParams,
    TaskDetailsRequestParamsFromJSON,
    TaskDetailsRequestParamsToJSON,
} from '../models/TaskDetailsRequestParams';

export interface GetAllLogsRequest {
    params: TaskDetailsRequestParams;
}

export interface PollLogsRequest {
    params: TaskDetailsRequestParams;
}

/**
 * 
 */
export class LogControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for getAllLogs without sending the request
     */
    async getAllLogsRequestOpts(requestParameters: GetAllLogsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling getAllLogs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['params'] != null) {
            queryParameters['params'] = requestParameters['params'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/db-scheduler-api/logs/all`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getAllLogsRaw(requestParameters: GetAllLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLogsResponse>> {
        const requestOptions = await this.getAllLogsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLogsResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAllLogs(requestParameters: GetAllLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLogsResponse> {
        const response = await this.getAllLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for pollLogs without sending the request
     */
    async pollLogsRequestOpts(requestParameters: PollLogsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['params'] == null) {
            throw new runtime.RequiredError(
                'params',
                'Required parameter "params" was null or undefined when calling pollLogs().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['params'] != null) {
            queryParameters['params'] = requestParameters['params'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/db-scheduler-api/logs/poll`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async pollLogsRaw(requestParameters: PollLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogPollResponse>> {
        const requestOptions = await this.pollLogsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogPollResponseFromJSON(jsonValue));
    }

    /**
     */
    async pollLogs(requestParameters: PollLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogPollResponse> {
        const response = await this.pollLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
